import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.grupo.invoice_manager'),
      // icon: 'group',
      // color: null,
      create: false,
    },
    {
      id: 2,
      name: i18n.t('tipos.grupo.management'),
      // icon: 'group',
      // color: null,
      create: true,
    },
    // {
    //   id: 3,
    //   name: 'Reparto',
    //   // icon: 'group',
    //   // color: null,
    //   create: true,
    // },
    // {
    //   id: 4,
    //   name: 'Administradores',
    //   icon: 'group',
    //   color: null,
    //   create: false,
    // },
  ]
}

export function TIPOS_GRUPO (state) {
  return configHelper.getConfig(state, 'TIPOS_GRUPO', GenerateConfig)
}
